import { objectToDottedPaths, updatedDiff } from '@kp/utils';

import type { TiiaModel } from '@kp/interfaces';
import type { DeepPartial } from '@kp/types';

export function updateModelWithPaths(
  oldModel: DeepPartial<TiiaModel>,
  model: DeepPartial<TiiaModel>,
): [Array<string>, DeepPartial<TiiaModel>] {
  const diff = updatedDiff(
    oldModel as Record<string, unknown>,
    model as Record<string, unknown>,
  ) as Record<string, unknown>;
  const paths = objectToDottedPaths(diff);

  return [paths, model];
}
